import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { VolunteeringSpecialistsService } from '../volunteering-specialists.service';
import { ApprovedSpecialistsByTopicViewPart } from './approved-specialists-by-topic/approved-specialists-by-topic.part';
import { NotApprovedSpecialistsByTopicViewPart } from './not-approved-specialists-by-topic/not-approved-specialists-by-topic.part';
import { SessionAssignmentsViewPart } from './session-assignments/session-assignments.part';
import { SignUpsViewPart } from './sign-ups/sign-ups.part';
import { SpecialistPoolViewPart } from './specialist-pool/specialist-pool.part';

@Component({
	selector: 'volunteering-specialists-views-part',
	standalone: true,
	imports: [
		SignUpsViewPart,
		SessionAssignmentsViewPart,
		SpecialistPoolViewPart,
		ApprovedSpecialistsByTopicViewPart,
		NotApprovedSpecialistsByTopicViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-specialists-views.part.html',
})

export class VolunteeringSpecialistsViewsPart implements OnInit {

	public service = inject(VolunteeringSpecialistsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}